import { SignUpParent } from '@app/auth/components/SignUpParent';
import { LightLayout } from '@app/layouts';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { activeTenant } from '@app/tenant';
import { readTenantEnv } from '@app/tenant/env';

export const SignUpParentPage = () => {
  const reCaptchaKey = (activeTenant ? readTenantEnv(activeTenant.slug, 'GOOGLE_RECAPTCHA_KEY') : '') || '';

  return (
    <LightLayout>
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
        <SignUpParent />
      </GoogleReCaptchaProvider>
    </LightLayout>
  );
};
